import { restfulClient, actionClient } from '@/api'

const taskUrl = '/credit-task'

export const taskApi = params => restfulClient.getCollection(taskUrl, params)
export const taskUpdateApi = params => restfulClient.replace(taskUrl, params.id, params)
